export default "__VITE_ASSET__DwgOEEw3__"